import { Model } from '@vuex-orm/core';

export default class Objektart extends Model {
  static entity = 'objektart';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {number} */
    this.id;
    /** @type {string} */
    this.name;
  }

  static fields() {
    return {
      id: this.number(null),
      name: this.string('')
    };
  }
}
